<template>
  <div>
    <div class="header">
      <span>地域统计</span>
      <el-form :inline="true" class="header-right">
        <el-form-item>
          <el-cascader
            size="mini"
            style="width: 150px"
            @change="selectOrg"
            ref="cascader"
            @visible-change="orgChange"
            :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'children' }"
            :options="orgs"
            v-model="orgIndex">
          </el-cascader>
        </el-form-item>
        <el-form-item>
          <el-radio-group v-model="dateRadio" size="mini" @change="dateRadioChange">
            <el-radio-button label="年"></el-radio-button>
            <el-radio-button label="月"></el-radio-button>
            <el-radio-button label="日"></el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            style="width: 130px"
            v-model="start"
            :type="dateType"
            size="mini"
            placeholder="开始日期"
            @change="dateChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            style="width: 130px"
            v-model="end"
            :type="dateType"
            size="mini"
            placeholder="结束日期"
            @change="dateChange">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="circle-warp" v-loading="loading" v-if="recordPositionList.length > 0">
      <div v-if="showChild" class="exCircle" style="background-color: #1890ff;" @click="back()">
        <div class="inCircle">
          <i class="el-icon-back" style="font-size: 80px; text-align: center; line-height: 110px; color: #1890ff"></i>
        </div>
        <div class="circle-name">返回上一级</div>
      </div>
<!--      <transition-group name="positionList" tag="div">-->
        <div class="exCircle positionList-item"
             v-for="item in recordPositionList"
             v-bind:key="item.positionsn"
             @click="toChild(item)"
             :style="{backgroundColor: item.total === 0 ? '#D9D9D9'  :'#7ecf51'}">
          <div class="inCircle">
            <div style="position: absolute; width: 100%; top: -10px;">
              <div style="height: 32px; font-size: 32px">
                {{Number(item.total / allTotal *100).toFixed() + "%"}}
              </div>
              <div style="height: 25px; font-size: 16px; color: #989898">
                {{item.total}}人
              </div>
            </div>
          </div>
          <div class="circle-name">{{item.positionname}}</div>
        </div>
<!--      </transition-group>-->
    </div>
    <div v-if="recordPositionList.length === 0" style="height: 330px; text-align: center; padding-top: 20px;">暂无数据</div>
  </div>
</template>
<script>
import _ from 'lodash'
import moment from 'moment'
import RecordCountService from '@/request/count/record'
export default {
  name: 'CountPosition',
  components: {},
  props: {
    orgs: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data () {
    return {
      start: moment().subtract(6, 'days').startOf('day').valueOf(), // 开始时间
      end: moment().endOf('day').valueOf(), // 结束时间
      dateRadio: '日',
      dateType: 'date',
      recordPositionList: [],
      showChild: false,
      value: 0,
      oids: [], // 选中组织的所有科室id
      oid: 0, // 记录oid 以便和 selectOrgs的id 比较 是否进行重新查询数据
      orgIndex: [], // 默认组织
      allTotal: 0,
      psn: null,
      loading: true,
      selectOrgs: null,
    }
  },
  computed: {},
  created() {
    this.init();
  },
  watch: {
    orgs() {
      this.init();
    },
  },
  methods: {
    init() {
      if (this.orgs.length > 0) {
        this.orgIndex = [this.orgs[0].id]
        let _oids = [];
        _.forEach(this.orgs[0].children, val => {
          _oids = _.concat(_oids, val.childrenIds || [])
        })
        this.oid = this.orgs[0].id
        this.oids = _oids;
        this.loadData();
      }
    },
    loadData (level, psn) {
      this.loading = true;
      let type = 'day';
      if (this.dateType !== 'date') {
        type = this.dateType
      }
      RecordCountService.countPosition({
        oids: this.oids.toString() || null,
        psn: psn || null,
        level: level || 1,
        start: moment(this.start).startOf(type).valueOf(),
        end: moment(this.end).endOf(type).valueOf(),
      }).then( res => {
        this.recordPositionList = res.result || [];
        this.allTotal = 0;
        _.forEach(this.recordPositionList, value => {
          this.allTotal = this.allTotal + value.total;
        });
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })
    },
    toChild(position) {
      this.loading = true;
      if (this.showChild) {
        this.loading = false;
        return
      }
      if (position) {
        this.showChild = true;
        this.loadData(2, position.positionsn)
      }
    },
    /**
     * 返回
     */
    back() {
      this.loading = true;
      this.showChild = false;
      this.loadData();
      this.loading = false;
    },
    selectOrg(index) {
      let orgs = _.cloneDeep(this.orgs);
      _.forEach(index, (val, i) => {
        let orgIndex = null;
        if (i === 0) {
          orgIndex = _.findIndex(orgs, {id: val});
          orgs = orgs[orgIndex];
        } else {
          orgIndex = _.findIndex(orgs.children, {id: val});
          orgs = orgs.children[orgIndex];
        }
      });
      this.selectOrgs = orgs
    },
    orgChange (hide) {
      if (!hide && this.selectOrgs) {
        const _orgid = this.selectOrgs.id;
        if (this.oid !== _orgid) {
          this.oid = _orgid;
          let _oids = []
          if (this.selectOrgs.typeId === 1) {
            _.forEach(this.selectOrgs.children, val => {
              _oids = _.concat(_oids, val.childrenIds || val.id)
            })
          } else {
            _oids = this.selectOrgs.childrenIds || this.selectOrgs.id
          }
          this.oids = _oids
          this.loadData()
        }
      } else {
        this.$nextTick(() => {
          const lis = this.$refs.cascader.panel.$el.lastChild.querySelectorAll('li')
          _.forEach(lis, val => {
            if (val.className.indexOf('is-active') !== -1) {
              val.click()
            }
          })
        })
      }
    },
    dateRadioChange(event) {
      switch (event) {
        case '年':
          this.dateType = 'year';
          this.start = moment().subtract(4, 'year').startOf('year').valueOf(); // 开始时间
          this.end =  moment().endOf('year').valueOf(); // 结束时间
          break;
        case '月':
          this.dateType = 'month';
          this.start = moment().subtract(12, 'month').startOf('month').valueOf(); // 开始时间
          this.end =  moment().endOf('month').valueOf(); // 结束时间
          break;
        default:
          this.dateType = 'date';
          this.start = moment().subtract(6, 'days').startOf('day').valueOf(); // 开始时间
          this.end =  moment().endOf('day').valueOf(); // 结束时间
      }
      this.dateChange();
    },
    dateChange() {
      if (!this.start || !this.end) {
        this.$message({
          message: '开始时间或结束时间不能为空',
          type: 'warning'
        });
        return
      }
      if (this.start > this.end) {
        this.$message({
          message: '开始时间不能大于结束时间',
          type: 'warning'
        });
      }
      this.loadData();
    }
  },
  filters: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .positionList-item {
    display: inline-block;
  }
  >>> .positionList-enter-active, .positionList-leave-active {
    transition: all 1s;
  }
  >>> .positionList-enter, .positionList-leave-to
    /* .list-leave-active for below version 2.1.8 */ {
    opacity: 0;
    transform: translateX(30px);
  }
  .header {
    height: 50px;
    line-height: 48px;
    color: #000;
    border-bottom: 1px solid #ebeef5;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 20px;
    position: relative;
  }
  .header-right{
    z-index: 999;
    float: right;
    position: absolute;
    right: 0;
    top: 4px;
  }
  .circle-warp {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    min-height: 150px;
  }
  .exCircle {
    margin: 30px 26px;
    width: 120px;
    height: 120px;
    border-radius: 120px;
    position: relative;
  }
  .inCircle{
    margin-top: 5px;
    margin-left: 5px;
    position: absolute;
    width: 110px;
    height: 110px;
    font-size: 21px;
    color: #666666;
    border-radius: 110px;
    text-align: center;
    line-height: 110px;
    background-color: #FFFFFF;
  }
  .circle-name {
    bottom: -50px;
    left: 0;
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    position: absolute;
  }
  .user-name {
    text-align: center;
    position: absolute;
    bottom: -10px;
    left: 26px;
    width: 120px;
    max-height: 40px;
  }
</style>
